export default function createGeoPosition({ longitude, latitude }) {
  return {
    longitude: parseFloat(longitude) || undefined,
    latitude: parseFloat(latitude) || undefined,
  };
}
